exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".HoverTab{height:100%;justify-content:center;align-items:center}", ""]);

// exports
